export enum BarcodeInputMethod {
  BarcodeReader = 'BarcodeReader',
  VirtualKeyboard = 'VirtualKeyboard',
  VirtualKeyboardCharsOnly = 'VirtualKeyboardCharsOnly',
  VirtualKeyboardNumbersOnly = 'VirtualKeyboardNumbersOnly',
  BarcodeReaderAndVirtualKeyboard = 'BarcodeReaderAndVirtualKeyboard',
  BarcodeReaderAndVirtualKeyboardCharsOnly = 'BarcodeReaderAndVirtualKeyboardCharsOnly',
  BarcodeReaderAndVirtualKeyboardNumbersOnly = 'BarcodeReaderAndVirtualKeyboardNumbersOnly'
}
